import { Queue, QueueProps } from 'src/utilities/queue';

import { concat, flatten, isEmpty, length, map, omit, path, uniq, uniqBy } from 'ramda';

import { NodeProp, Node } from 'src/utilities/node';
import { isNotEmpty } from './hasValue';

export class Tree {
  _root: NodeProp = { data: {}, parent: {}, children: [] };
  constructor(data: any) {
    this._root = new Node(data);
  }
}

/**
 * getAdjacentNodes method to get the adjacent nodes for a node in a tree structure
 *
 * @param rootNode should give root node of an tree
 * @param nodeName should be a node name for which adjacent nodes is needed
 * @description BFS traversal of stage tree
 */
export const getAdjacentNodes = (rootNode: any, nodeName: string) => {
  // Que is formed
  let que: QueueProps<any> = new Queue();
  if (rootNode == null) {
    return 0;
  }
  let items: any = [];
  // root node is pushed to que
  que.push(rootNode);
  while (!isEmpty(que)) {
    /*initally root node will be there ,but while in process nodes will get added up in que*/
    const p = que._store[0] || [];
    /*after taking first node ,first node will be removed from que */
    que.shift();
    /*if first node childrens is itself empty,then there is no children for the root nodes */
    if (!isNotEmpty(p)) {
      return items;
    }
    let i;
    /* checking for the name of the node, if it equals then childrens of the node will be returned
        if it not equals then ,children of checked nodes will be pushed into que for anlaysis of
        children nodes
        */
    for (i = 0; i <= length(p.children); i++) {
      if (p.children[i]?.data.value == nodeName) {
        items = concat(uniq([...p.children[i].children]), items);
        return items;
      }
      if (isNotEmpty(p?.children[i]?.children)) {
        que.push(p.children[i]);
      }
    }
    /*if root node equals then root nodes children will be returned */
    if (p?.data?.value === nodeName) {
      items = concat(p.children, items);
      return items;
    }
  }
};

/**
 * getPossiblePathsOfAnRoot method to get the all possible paths of an N-array tree,
 * Reference of this alogothirm "https://stackoverflow.com/questions/51911114/print-all-the-path-of-n-ary-tree-python"
 * @param node initally root node will be given
 * @param path intially be a empty list,will be internally used by this function
 * @param paths intially be a empty list,will be internally used by this function
 */
export const getPossiblePathsOfAnRoot = (node: any, path: any, paths: any) => {
  /* root node children is pushes to childrens and first node of an path will be root node */
  let childrens = node.children;
  path.push(node);
  /* if there is no sub childrens of root nodes then there is no path,so pushing the root node */
  if (childrens?.length == 0) {
    paths.push(path.slice());
    path.pop();
  } else {
    /*if there is more than one chilren ,pushing the children and agin iteration the childrens
        of children node and pushing into paths array,finally we will be able to get the
        possible paths of an tree structure*/
    for (let i = 0; i < childrens?.length; i++) {
      getPossiblePathsOfAnRoot(childrens[i], path, paths);
    }
    path.pop();
  }

  return paths;
};

export const traverseBF = (treeRoot: any) => {
  let queue: QueueProps<any> = new Queue();
  queue.push(treeRoot);
  let tree = [treeRoot];
  let currentTree = queue._store[0];
  while (currentTree) {
    let i = 0;
    for (i = 0; isNotEmpty(currentTree.children) && i < currentTree.children.length; i++) {
      queue.push(currentTree.children[i]);
      tree.push(currentTree.children[i]);
      //FIX-ME: Currently the substage under a stage has a limit set to 9.
      // eg: As a loan officer when i click on 
      //[Application Decision] stage the drop down has
      //[Active, With drawn, Declined ...] and the limit is 9
      if (i == 23) {
        return;
      }
    }
    queue.shift();
    currentTree = queue._store[0];

    traverseBF(currentTree);
  }
  return uniqBy(path(['data', 'value']), flatten(map((x: any) => omit(['children', 'parent'], x), tree)));
};
